import React, { Component } from 'react';
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Link, NavLink, Route, Switch, useHistory, withRouter } from 'react-router-dom';

import Graph from "../../../../components/etc/Graph";

import { bindActionCreators } from "redux";
import * as Actions from "../../../../store/modules/scholars";

import { getDateFormat } from "../../../../utils/functions"

import { BASE_PATH } from "../../../../wpconfig";
import SBasic from "./module/0_Basic";
import SBasicMeta from "./module/1_BasicMeta";
import SIntroduce from "./module/2_Introduce";
import SAchievement from "./module/3_Achievement";
import SResources from "./module/4_Resources";
import SChart from "./module/5_Chart";
import JBasic from "../../../journal/front/detail/module/0_Basic";
// import SBasicMeta from "./module/1_BasicMeta";
// import SImpactFactor from "./module/2_ImpactFactor";
// import SInformation from "./module/3_Information";
// import SImpactFactorChange from "./module/4_ImpactFactorChange";
// import SCategoryRank from "./module/5_CategoryRank";
// import SChange from "./module/6_Change";
// import SAlticle from "./module/9_Article";
// import SDepartments from "./module/7_Departments";
// import SResearchers from "./module/8_Researchers";

class ScholarContent extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
	}

	linkToList = () => {
		// this.props.history.push(BASE_PATH + "scholars/");
	}

	render() {
		const record = this.props.record;
		const code = this.props.code

		// const stats = this.props.stats;
		// if(!record.scholar_name)
		// 	return '';
		// console.log(stats);
		return (
			<div className="center-group">
				<SBasic record={record} code={code} />
				<SBasicMeta record={record} />
				<SIntroduce record={record} />
				<SAchievement record={record} />
				<SResources record={record}/>
				{/*<SChart record={record}/>*/}
			</div>
		)
	}
}

export default connect(
	(state) => ({
		record: state.scholars.record ? state.scholars.record : {},
		stats: state.scholars.stats ? state.scholars.stats : {},
		code: state.scholars.code ? state.scholars.code : {},
	}),
	(dispatch) => ({
		// dataActions: bindActionCreators(Actions, dispatch)
	}),
)(ScholarContent)

ScholarContent.propTypes = {
	// args : PropTypes.object,
	// facet : PropTypes.object,
};
